import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProjectUpdateUI from './ProjectUpdateUI.js'

class ProjectUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // project type
      projectType: this.props.project.projectType,
      // project name
      projectName: this.props.project.projectName,
      projectNameError: null,
      // short code
      shortCode: this.props.project.shortCode,
      shortCodeError: null,
      // project statuses
      status: this.props.project.status,
      statusList: null,
      // project visibilities
      visibility: this.props.project.visibility,
      visibilityList: null,
      // project code
      projectCode: this.props.project.projectCode || '',
      projectCodeError: null,
      // description
      description: this.props.project.description || '',
      descriptionError: null,
      // announcement
      announcement: this.props.project.announcement || '',
      announcementError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <ProjectUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // project type
        projectType={this.state.projectType}
        // project name
        projectName={this.state.projectName}
        onProjectNameChange={(event) => {this.setState({projectName: event.target.value})}}
        projectNameError={this.state.projectNameError}
        setProjectNameError={(error) => {this.setState({projectNameError: error})}}
        // project name
        shortCode={this.state.shortCode}
        onShortCodeChange={(event) => {this.setState({shortCode: event.target.value.toUpperCase()})}}
        shortCodeError={this.state.shortCodeError}
        setShortCodeError={(error) => {this.setState({shortCodeError: error})}}
        // status
        status={this.state.status}
        statusList={this.state.statusList}
        onStatusChange={(event) => {this.setState({status: event.target.value})}}
        // visibility
        visibility={this.state.visibility}
        visibilityList={this.state.visibilityList}
        onVisibilityChange={(event) => {this.setState({visibility: event.target.value})}}
        // project code
        projectCode={this.state.projectCode}
        onProjectCodeChange={(event) => {this.setState({projectCode: event.target.value.replace(/[^a-z0-9]+/g, '-')})}}
        projectCodeError={this.state.projectCodeError}
        setProjectCodeError={(error) => {this.setState({projectCodeError: error})}}
        // description
        description={this.state.description}
        onDescriptionChange={(event) => {this.setState({description: event.target.value})}}
        descriptionError={this.state.descriptionError}
        setDescriptionError={(error) => {this.setState({descriptionError: error})}}
        // announcement
        announcement={this.state.announcement}
        onAnnouncementChange={(event) => {this.setState({announcement: event.target.value})}}
        announcementError={this.state.announcementError}
        setAnnouncementError={(error) => {this.setState({announcementError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  UNSAFE_componentWillMount() {
    let context = this.props.context
    this.getProjectStatuses(context)
    this.getProjectVisibilities(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context

    RestApiUtils.put(context,
      `/api/accounts/${context.session.accountId}/projects/${this.props.project.projectId}`,
      this.onSubmitCallback, {
        projectName: this.state.projectName,
        shortCode: this.state.shortCode,
        status: this.state.status,
        visibility: this.state.visibility,
        projectCode: this.state.projectCode,
        description: this.state.description,
        announcement: this.state.announcement,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'projectName':
          this.setState({projectNameError: error.message})
          break;
        case 'projectCode':
          this.setState({projectCodeError: error.message})
          break;
        case 'description':
          this.setState({descriptionError: error.message})
          break;
        case 'announcement':
          this.setState({announcementError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    let context = this.props.context
    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      setTimeout(() => {
        this.props.history.push('/projects')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getProjectStatuses(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/project-statuses`,
      cacheKey: CacheKeys.ProjectStatuses(),
      callback: this.getProjectStatusesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectStatusesCallback = (response) => {
    let statusList = Object.keys(response.projectStatusMap)
      .map(key => ({key: key, value: response.projectStatusMap[key]}))
    this.setState({
      statusList: statusList,
    })
  }

  getProjectVisibilities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/project-visibilities`,
      cacheKey: CacheKeys.ProjectVisibilities(),
      callback: this.getProjectVisibilitiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectVisibilitiesCallback = (response) => {
    let visibilityList = Object.keys(response.projectVisibilityMap)
      .map(key => ({key: key, value: response.projectVisibilityMap[key]}))
    this.setState({
      visibilityList: visibilityList,
    })
  }

}

export default withRouter(ProjectUpdateSF)
